const KEYS = {
  externalLinks: 'zion_allow_external_links',
  autoMedia: 'zion_auto_media_download',
  requireUnlock: 'zion_require_unlock_on_open',
  wipeOnExit: 'zion_wipe_on_exit',
} as const

function readBool(key: string, defaultValue: boolean): boolean {
  try {
    const v = localStorage.getItem(key)
    if (v === null) return defaultValue
    return v === '1' || v === 'true'
  } catch {
    return defaultValue
  }
}

function writeBool(key: string, value: boolean): void {
  localStorage.setItem(key, value ? '1' : '0')
}

/** Link esterni e anteprime — default ON */
export function getAllowExternalLinks(): boolean {
  return readBool(KEYS.externalLinks, true)
}

export function setAllowExternalLinks(value: boolean): void {
  writeBool(KEYS.externalLinks, value)
}

/** Download automatico media — default ON */
export function getAutoMediaDownload(): boolean {
  return readBool(KEYS.autoMedia, true)
}

export function setAutoMediaDownload(value: boolean): void {
  writeBool(KEYS.autoMedia, value)
}

/** Password all'apertura — default ON */
export function getRequireUnlockOnOpen(): boolean {
  return readBool(KEYS.requireUnlock, true)
}

export function setRequireUnlockOnOpen(value: boolean): void {
  writeBool(KEYS.requireUnlock, value)
}

/** Wipe cache/IDB su exit — default OFF */
export function getWipeOnExit(): boolean {
  return readBool(KEYS.wipeOnExit, false)
}

export function setWipeOnExit(value: boolean): void {
  writeBool(KEYS.wipeOnExit, value)
}
